import { v4 as uuid } from "uuid";
export interface IDocument {
  key: string,
  name: string,
  type: string,
  orgName: string,
  size: number,
  enddate: string,
  description: string,
  file: string,
}

export class DocumentModel implements IDocument {
  key: string;
  name: string;
  type: string;
  orgName: string;
  enddate: string;
  size: number;
  description: string;
  file: string;

  constructor() {
    this.key = uuid().slice(0, 8);
  }      


}